import React from 'react'
import {
    BackButton,
    Bloc,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue3() {
    return (
        <div>
            <Header title="J'estime mon prêt" subTitle="Pour quel usage ?" />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <Conditionnal
                        linked_data_id="tech_type_action_depart"
                        isEqualTo
                        targetDataValueCompare="comparer"
                    >
                        <BackButton targetView={17} />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="tech_type_action_depart"
                        isNotEqualTo
                        targetDataValueCompare="comparer"
                    >
                        <BackButton />
                    </Conditionnal>
                </div>

                <div className="InfoBulleContainerRight"></div>
            </div>
            <div className="Container">
                <ProgressBar size={12} time={4} />
            </div>
            <div className="Container">
                <Conditionnal
                    linked_data_id="prj_type"
                    isNotEqualTo
                    targetDataValueCompare="RENEGOCIATION"
                >
                    <Bloc
                        key="key11"
                        selectable
                        linked_data_id="prj_usage"
                        linked_data_value="RES_PRINCIPALE"
                        targetView={4}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="png/cred_rp.png"
                        text1="Résidence"
                        text2="principale"
                    />
                </Conditionnal>
                <Conditionnal
                    linked_data_id="prj_type"
                    isEqualTo
                    targetDataValueCompare="RENEGOCIATION"
                >
                    <Bloc
                        key="key11"
                        selectable
                        linked_data_id="prj_usage"
                        linked_data_value="RES_PRINCIPALE"
                        linked_data_id_2="emprunteurs_hab_actuelle"
                        linked_data_value_2="PROPRIETAIRE"
                        targetView={4}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="png/cred_rp.png"
                        text1="Résidence"
                        text2="principale"
                    />
                </Conditionnal>
                <Bloc
                    key="key12"
                    selectable
                    linked_data_id="prj_usage"
                    linked_data_value="LOCATIF"
                    targetView={4}
                    nbcolumn={2}
                    droit
                    imageTextStyle
                    logourl="svg/locatif.svg"
                    text1="Investissement"
                    text2="locatif"
                />
                <Bloc
                    key="key13"
                    selectable
                    linked_data_id="prj_usage"
                    linked_data_value="RES_SECONDAIRE"
                    targetView={4}
                    nbcolumn={2}
                    gauche
                    imageTextStyle
                    logourl="svg/res_secondaire.svg"
                    text1="Résidence"
                    text2="secondaire"
                />
            </div>
        </div>
    )
}
